import axios from 'axios';
import { expireSession } from './session';

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL
    || (process.env.NODE_ENV === 'production'
        ? 'https://epraggies.rasspl.co.za/app/'
        : 'http://localhost:8080/');

const api = axios.create({
    baseURL: apiBaseUrl,
    withCredentials: true,
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            expireSession();
        }
        return Promise.reject(error);
    },
);

export default api;
